import TableSorter from 'components/general/tableSorter';
import { ArrayHelpers, Paging, SystemText } from 'e4shared';
import { e4Format } from 'helpers/dates';
import React from 'react';

export const Summary = ({ data }) => {
    const [sortBy, setSortBy] = React.useState('name');
    const [descending, setDescending] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const [filteredData, setFilteredData] = React.useState([]);
    const pageSize = 20;

    const sortProps = {
        sortBy,
        descending,
        setSortBy,
        setDescending,
    };

    React.useEffect(() => {
        setPage(1);
    }, [data, sortBy, descending]);

    React.useEffect(() => {
        const d = descending ? -1 : 1;
        const temp = [...data].sort((a, b) => (a[sortBy] > b[sortBy] ? 1 * d : -1 * d));
        setFilteredData(ArrayHelpers.getPage(temp, page, pageSize));
    }, [data, sortBy, descending, page]);

    return (
        <div>
            <table className="table table-striped">
                <thead>
                    <tr>
                        <th>
                            <TableSorter default column="name" {...sortProps}>
                                {SystemText('PathwayTracker/Tabs/Summary/Table/Headers/Pathway')}
                            </TableSorter>
                        </th>
                        <th>
                            <TableSorter column="firstAssigned" {...sortProps}>
                                {SystemText('PathwayTracker/Tabs/Summary/Table/Headers/First')}
                            </TableSorter>
                        </th>
                        <th>
                            <TableSorter column="lastAssigned" {...sortProps}>
                                {SystemText('PathwayTracker/Tabs/Summary/Table/Headers/Last')}
                            </TableSorter>
                        </th>
                        <th>
                            <TableSorter column="timesTaken" {...sortProps}>
                                {SystemText('PathwayTracker/Tabs/Summary/Table/Headers/Started')}
                            </TableSorter>
                        </th>
                        <th>
                            <TableSorter column="timesCompleted" {...sortProps}>
                                {SystemText('PathwayTracker/Tabs/Summary/Table/Headers/Completed')}
                            </TableSorter>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {filteredData.map(row => {
                        return (
                            <tr key={`summary-${row.id}`}>
                                <td>{row.name}</td>
                                <td>{e4Format(row.firstAssigned, null, null, '-')}</td>
                                <td>{e4Format(row.lastAssigned, null, null, '-')}</td>
                                <td>{row.timesTaken}</td>
                                <td>{row.timesCompleted}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            <div className="text-center">
                <Paging recordCount={data.length} page={page} goToPage={setPage} pageSize={pageSize} />
            </div>
        </div>
    );
};

export default Summary;
